import {PuiDialog} from "@portnet/ui";
import React from "react";

const AppDialog = React.forwardRef((props, ref) => {
  return <PuiDialog ref={ref} {...props} />;
});

export default AppDialog;
